const KEY = "cp_recent";
export const RECENT_MAX = 8;

export const getRecent = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]").filter((x) => typeof x === "string"); } catch { return []; }
};

export const addRecent = (id) => {
  if (!id) return;
  const next = [id, ...getRecent().filter((x) => x !== id)].slice(0, RECENT_MAX);
  try { localStorage.setItem(KEY, JSON.stringify(next)); } catch { /* storage full or blocked */ }
};

export const clearRecent = () => { try { localStorage.removeItem(KEY); } catch { /* blocked */ } };
